export default {
  name: "StyleMessage",
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    remove: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      visible: false
    };
  },
  created() {
    this.onOpen(this.config);
  },
  methods: {
    onClose() {
      this.visible = false;
      setTimeout(() => {
        this.remove();
      }, 200);
    },
    onOpen(config) {
      setTimeout(() => {
        this.visible = true;
      }, 10);
      if (config.duration !== 0) {
        setTimeout(() => {
          this.onClose();
        }, config.duration || 3000);
        // }, 300000);
      }
    }
  }
};